import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Table, Typography } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";
export const Container = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",

  gap: "20px",
  backgroundColor: theme.palette.background.default,
  // padding: "15px",
  borderRadius: "0 0 10px 10px",
  "& .MuiBadge-badge": {
    right: "11px !important",
    bottom: "4px !important",
  },
  [theme.breakpoints.down("lg")]: {
    flexWrap: "wrap",
    "& >.MuiDivider-root": {
      display: "none",
    },
    "& >.MuiGrid-root:first-of-type": {
      order: 2,
      width: "100%",
    },
    "& >.MuiGrid-root:nth-of-type(2)": {
      width: "100%",
    },
  },
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  height: "min-content",
  tableLayout: "fixed",
  maxWidth: "100%",
  borderCollapse: "separate",
  [theme.breakpoints.down("lg")]: {
    order: 2,
  },
  "& .MuiTableRow-root": {
    "& .MuiTableCell-root": {
      padding: "10px",
      "&:first-of-type": {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
        width: "30%",
        maxWidth: "160px",
      },
      "&:last-of-type": {
        border: `1px solid ${theme.palette.background.paper}`,
        overflow: "auto",
      },
    },
    "&:first-of-type": {
      "& .MuiTableCell-root:first-of-type": {
        borderRadius: "5px 0px 0px 0px",
        backgroundColor: theme.palette.background.paper,
      },
      "& .MuiTableCell-root:last-of-type": {
        borderRadius: "0px 5px 0px 0px",
        border: `1px solid ${theme.palette.background.paper}`,
      },
    },
    "&:last-of-type": {
      "& .MuiTableCell-root:first-of-type": {
        borderRadius: "0px 0px 0px 5px",
        backgroundColor: theme.palette.background.paper,
      },
      "& .MuiTableCell-root:last-of-type": {
        borderRadius: "0px 0px 5px 0px",
        border: `1px solid ${theme.palette.background.paper}`,
      },
    },
  },
}));

export const AddDocumentContainer = styled(Grid)(({ theme }) => ({
  opacity: "0.3",
  ":hover": {
    opacity: 1,
  },
}));

export const DocumentContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "forManager",
})<{ forManager: boolean }>(
  ({ theme }) => ({
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    cursor: "pointer",

    borderRadius: "5px",
    // padding: "10px 15px",
    position: "relative",
    "& p": {
      fontSize: "0.7em",
    },
    "& svg": {
      color: lighten(theme.palette.primary.main, 0.5),
    },
  }),
  ({ forManager, theme }) => ({
    ...(forManager && {
      border: "1px solid transparent",
      "&:hover": {
        border: `1px solid ${lighten(theme.palette.primary.main, 0.5)}`,
        "& svg": {
          opacity: 1,
        },
      },
    }),
  })
);

export const AttachedDocumentContainer = styled(Grid)<{
  dir: "rtl" | "ltr";
}>(
  ({ theme }) => ({
    position: "absolute",
    top: "-13px",
    backgroundColor: theme.palette.background.default,
    width: "20px",
    height: "20px",
    textAlign: "center",
    "& svg": {
      color: lighten(theme.palette.primary.main, 0.5),
      opacity: 0,
      backgroundColor: theme.palette.background.default,
      width: "15px",
      height: "15px",
    },
  }),
  ({ dir }) => ({
    ...(dir === "ltr"
      ? { right: "4px" }
      : {
          left: "4px",
        }),
  })
);

export const DocumentType = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const FilesContainer = styled(Grid)({
  display: "flex",
  flex: "1",
  gap: "3px",
  padding: "3px",
});

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== "color",
})<{ color?: string }>(({ theme, color }) => ({
  color: color ?? theme.palette.primary.main,
}));

export const DocumentActionsContainer = styled(Grid)(({ theme }) => ({
  padding: "10px",
}));
export const VerfiyDocumentButtonText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  color: theme.palette.text.primary,
  backgroundColor: "none",
  border: "none",
  textTransform: "none",
}));
